module.exports = __webpack_public_path__ + "media/s1.3cd0d1c8.mp3";